(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/icon-button", [], factory);
	else if(typeof exports === 'object')
		exports["icon-button"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["icon-button"] = factory();
})(this, function() {
return 